import type { LogicalDeviceLocationGeofencing } from '../components/logical-device-location-card/logicalDeviceLocationCard.model';
import type { ReadonlyLabelWithIconData } from '../components/readonly-label-with-icon';
import type { DeviceAlerts } from '../model/deviceAlerts.model';

export function getDeviceGeofencingDetails(
  data: DeviceAlerts,
  formatDateFunc?: (date?: string) => string,
): LogicalDeviceLocationGeofencing {
  return {
    authorizedAreas: data.areas,
    sinceDate: formatDateFunc?.(data.sinceDate) ?? data.sinceDate,
  };
}

export function getDisplayedGeofenceData(geofencing?: LogicalDeviceLocationGeofencing): ReadonlyLabelWithIconData[] {
  return geofencing?.authorizedAreas?.length
    ? [
        {
          key: 'geofence-authorized-area',
          title: 'logicalDevice:deviceProperties.authorizedArea',
          value: geofencing.authorizedAreas?.join(' ; '),
        } as ReadonlyLabelWithIconData,
      ]
    : [];
}
